import Drawer from "./Drawer";
import Footer from "./Footer";
import Header from "./Header";

const Layout = (props) => {
  const { children, mint } = props;
  return (
    <div className="w-full">
      { mint ? (<><Drawer mint/>
      <Header mint/></>): <><Drawer />
      <Header /></>}
      <main className="w-full">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
